import React, { useEffect, useState } from "react";
import "./PaymentDonePage.css";
import verifiedLogo from "./image/verified-logo.png";
import foodImg from "./image/food-img.png";

import { RiArrowDropDownLine } from "react-icons/ri";
import { SlCalender } from "react-icons/sl";
import { IoMdStopwatch } from "react-icons/io";
import { TbUsers } from "react-icons/tb";
import { IoLocationOutline } from "react-icons/io5";
import { GiNotebook } from "react-icons/gi";
import { GiSandsOfTime } from "react-icons/gi";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../utils";


const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function PaymentDonePage() {

    const { id } = useParams();

    const [data, setData] = useState([]);

    const handleGetPaymentInfo = async () => {
        try {
            const formData = new FormData();
            formData.append("order_id", id);

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/getThankYouDetails`,
                formData,
            );


            console.log("response", response.data);
            if (response.data?.status) {
                setData(response.data.data);
            } else {
                console.warn("No valid data received:", response.data);
            }
        } catch (error) {
            console.error("Error fetching payment info:", error);
        }
    };


    useEffect(() => {
        handleGetPaymentInfo();
    }, []);


    return (
        <>
            <div className="payment-done-container">
                <div className="payment-card-d">

                    <div className="success-container-d-payment">
                    <div className="success-icon-d"><img src={verifiedLogo} alt="" /></div>
                    <h2 className="success-text-d">Payment Successful!</h2>
                    </div>

                    <div className="booking-status-container-d">
                        <div className="booking-status-card-d-wrapper">
                            <div className="booking-status-d">
                            <h6><span className="status-icon-d"><GiSandsOfTime size={25} /></span>  Waiting for Booking Confirmation<br /></h6>

                            <div className="status-text-d">
                                <p>
                                    We’ve notified <a href="#">{data?.club_name}</a> about your
                                    booking. You’ll receive a confirmation once the restaurant accepts
                                    your request.
                                </p>
                            </div>
                            </div>
                            <div className="button-container-d">
                                <Link to={`/add-menu/${data?.order_id}`} style={{ textDecoration: "none", width: "100%" }}>
                                <button className="button-container-menu-button-d">Choose Menu</button>
                                </Link>
                                <Link to={`/add-guest/${data?.order_id}`} style={{ textDecoration: "none", width: "100%" }}>
                                <button  className="button-container-menu-button-d">Create Invite List</button>
                                </Link>
                            </div>
                        </div>

                        <div className="summary-section-d">
                            <div className="summary-header-d">
                                <span className="summary-title-d">📋 View Party Summary</span>
                                <RiArrowDropDownLine size={25} />
                            </div>
                            <div className="summary-body-d">
                                <img
                                    src={url + data?.package_img}
                                    alt="Party"
                                    className="summary-image-d"
                                />
                                <div className="summary-details-d">
                                    <h4>{data?.package_title_name}</h4>
                                    <span>{data?.package_type}</span>
                                    <p className="venue-d">{data?.club_name}</p>
                                    <p><SlCalender />{data?.party_date}</p>
                                    <p><IoMdStopwatch />{data?.party_time}</p>
                                    <p><TbUsers />{data?.male} Male, {data?.female} Female</p>
                                    <p><IoLocationOutline />{data?.club_address}, {data?.area_name}, {data?.city_name}</p>
                                    <div className="badge-group-d">
                                        <span className="badge-d">Get Directions</span>
                                        <span className="badge paid-d">Amount Paid ₹ {data?.net_payable_amount}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="note-d">
                        <GiNotebook /> <strong>Note:</strong> Your booking will only be confirmed once the
                        restaurant accepts. You won’t be charged further until the full confirmation.
                    </div>
                </div>
            </div>
        </>
    );
}
